import { call, put, select, takeEvery } from "redux-saga/effects";
import { api } from "Shared/axios";

import { selectTimezone } from "./timezone-list.select";
import { timezoneActions } from "./timezone-list.slice";

function* fetchTimezoneWorker() {
	const result = [];
	const timezones = yield select(selectTimezone.list);
	if (timezones.length > 0) return;
	try {
		while (result.length === 0 || result.length % 40 === 0) {
			const { data } = yield call(api.get, "/timezone", {
				params: {
					offset: result.length,
					limit: 40,
				},
			});

			result.push(...data);
		}
	} catch (error) {
		console.error("fetchTimezoneWorker Error: ", error);
	} finally {
		yield put(timezoneActions.set(result));
	}
}

export function* watchTimezone() {
	yield takeEvery(timezoneActions.get, fetchTimezoneWorker);
}
